module.exports = __webpack_public_path__ + "media/images/smart_phone/sp_menu2_bg-340de03b87925b33377e70cfeed25235.png";